import { createSlice, createAsyncThunk } from "@reduxjs/toolkit"
import axios from "axios"
import RoutesMap from "../../../../route_control/RouteControl"
import { SessionManager, showAccessDeniedAlert, showTokenExpiredAlert } from "../../../../utils";

export const locationListTodo = createAsyncThunk('locationList', async ({ pageable: data, navigate }) => {

    try {
        const res = await axios({

            method: 'GET',
            url: process.env.REACT_APP_API_URL + `location`,
            params: {
                'pageSize': data?.pageSize,
                'pageNo': data?.currentPage,
                'search': data?.search,
            },
            headers: { "Content-Type": "application/json", "Authorization": SessionManager.getSession("user_token") }

        })
        return res
    } catch (error) {
        return error.response
    }
})

const locationListSlice = createSlice({
    name: 'locationList',
    initialState: {
        data: [],
    },
    extraReducers: (builder) => {
        builder.addCase(locationListTodo.fulfilled, (state, action) => {
           if (action?.payload?.status == 200) {
                state.data = action.payload.data.data;
            } else if (action?.payload?.status == 401) {
                 showTokenExpiredAlert(action?.payload?.data?.message, action.meta.arg.navigate);
            } else if (action?.payload?.status == 403) {
                showAccessDeniedAlert(action.meta.arg.navigate)
            } else {
                state.data = []
            }


        });
        builder.addCase(locationListTodo.rejected, (state, action) => {
            // console.log('reject', action)
        })
    }
})

export default locationListSlice.reducer; 